import { render, staticRenderFns } from "./TypoControl.vue?vue&type=template&id=68701b51"
import script from "./TypoControl.vue?vue&type=script&lang=js"
export * from "./TypoControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports